import ProfileForm from '../../components/ProfileForm/ProfileForm';

function Profile() {
  return <ProfileForm />;
}

export default Profile;
